import React from 'react';
import { graphql } from 'gatsby';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  CardCarousel,
  Section,
  SectionHeader,
} from '@lanl-web/lanl-components';
import { publishedFilter } from '../../utils';
import { Stories } from './Stories';

import './NewsCarousel.scss';

export const NewsCarousel = ({
  className,
  linkText,
  link,
  stories,
  storyType,
  title,
}) => {
  const classes = classNames('news-carousel', className);

  const publishedStories = publishedFilter(stories);

  return (
    <Section className={classes}>
      <SectionHeader link={link} linkText={linkText} title={title} />
      <CardCarousel length={publishedStories.length}>
        <Stories stories={publishedStories} storyType={storyType} />
      </CardCarousel>
    </Section>
  );
};

NewsCarousel.defaultProps = {
  link: '/posts',
  linkText: 'More Posts',
  stories: [],
  storyType: 'posts',
  title: 'New at the Research Library',
};

NewsCarousel.propTypes = {
  stories: PropTypes.array.isRequired,
  className: PropTypes.string,
  link: PropTypes.string,
  linkText: PropTypes.string,
  c: PropTypes.oneOf(['publications', 'news', 'posts', 'projects']),
  title: PropTypes.string,
};

export const query = graphql`
  fragment newsArticles on DirectusData {
    rl_news {
      title
      slug
      status
      card_image {
        filename_disk
      }
      feature_image {
        filename_disk
      }
    }
  }
`;

export default NewsCarousel;
